export default "__VITE_ASSET__fcd68a25__"